/*
 * document-types.ts — document types loading and selection dropdown management.
 */


import { getErrorMessage } from "./helpers";
import { fetchDocumentType, DocType  } from "./bc-api";
import { getBcRequestContext } from "../shared/auth-state";

export const DocumentTypes: DocType[] = [];

// ─── Load Document Types ─────────────────────────

export async function loadDocTypes(): Promise<void> {

    try {
      const bc = await getBcRequestContext(false);
      const found = await fetchDocumentType(bc);

      // Replace wholesale, not merge -- DocumentTypes must reflect only the currently
      // selected company (bc.companyId above). Appending onto whatever was already there
      // would leave a previous company's document types mixed in after a company switch.
      DocumentTypes.length = 0;
      const seenCodes = new Set<string>();
      found.forEach((cat) => {
        if (seenCodes.has(cat.code)) return; // defensive: BC shouldn't return duplicate codes
        seenCodes.add(cat.code);
        DocumentTypes.push(cat);
      });

      // fetchDocumentType already asks BC to order by emailBridgeSequence,code; re-sorting
      // here is just a defensive guarantee in case that ordering is ever not honored.
      DocumentTypes.sort((a, b) => a.emailBridgeSequence - b.emailBridgeSequence || a.code.localeCompare(b.code));

    } catch (err: unknown) {
      console.log("Get Doc Type Err:", getErrorMessage);
      if (err instanceof DOMException && err.name === "AbortError") return;

      DocumentTypes.length = 0;
    }
}

